import { useState } from "react";
import {
  getMonthlyAll,
  getMonthlyContent,
} from "../../../services/monthlyPlan.service";

export const useMonthlyPlan = ({ atcu, year, selectedtMonth }) => {
  const [loading, setLoading] = useState(true);
  const [monthlyContentLoaded, setMonthlyContentLoaded] = useState(false);
  const [dataCalculated, setDataCalculated] = useState(false);
  const [dataSourceMonthlyAll, setDataSourceMonthlyAll] = useState();
  const [dataSourceMonthlyContent, setDataSourceMonthlyContent] = useState();
  const [dataSourceMonthlyAllNextMonth, setDataSourceMonthlyAllNextMonth] =
    useState();
  const [
    dataSourceMonthlyContentNextMonth,
    setDataSourceMonthlyContentNextMonth,
  ] = useState();
  const today = new Date().getDate();

  const updateLoading = () => {
    if (loading && monthlyAllLoaded && monthlyContentLoaded) {
      setLoading(false);
    } else setLoading(true);
  };

  const fetchMonthlyAll = async () => {
    setLoading(true);
    let dataAll = [];
    let dataAllNextMonth = [];
    let dataContent = [];
    let dataContentNextMonth = [];
    try {
      const response1 = await getMonthlyAll(atcu, year, selectedtMonth);
      const version = response1.data?.[0]?.versions?.[0]?.version;
      dataAll = response1.data;
      const response2 = await getMonthlyContent(
        atcu,
        year,
        selectedtMonth,
        version
      );
      dataContent = response2.data;

      if (today > 15) {
        const nextMonth = selectedtMonth === 12 ? 1 : selectedtMonth + 1;
        const nextYear = selectedtMonth === 12 ? year + 1 : year;

        const response3 = await getMonthlyAll(atcu, nextYear, nextMonth);
        dataAllNextMonth = response3.data;
        const versionNextMonth = response3.data?.[0]?.versions?.[0]?.version;
        const response4 = await getMonthlyContent(
          atcu,
          nextYear,
          nextMonth,
          versionNextMonth
        );
        dataContentNextMonth = response4.data;
      }
      setDataSourceMonthlyAll(dataAll);
      setDataSourceMonthlyAllNextMonth(dataAllNextMonth);
      setDataSourceMonthlyContent(dataContent);
      setDataSourceMonthlyContentNextMonth(dataContentNextMonth);
    } catch (error) {
      console.error("Error fetching monthly data:", error);
      setDataSourceMonthlyAll([]);
      setDataSourceMonthlyContent([]);
      setDataSourceMonthlyContentNextMonth([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchMonthlyAll,
    dataSourceMonthlyAll,
    dataSourceMonthlyAllNextMonth,
    dataSourceMonthlyContent,
    dataSourceMonthlyContentNextMonth,
    dataCalculated,
    setDataCalculated,
    loading,
    updateLoading,
  };
};
